import { register } from '@shopify/theme-sections'
import '../../styles/sections/index-contact.scss'
import { getSalesforceEndpoints } from '../util/getSalesforceEndpoints'

export function ContactForm() {
  const submitForm = document.querySelector(`#contactSubmit`)
  const contactForm = submitForm && submitForm.closest(`#sc-contact-form`)
  const businessType = document.querySelector(`[name="nature_of_business"]`)

  const { action_contact_url } = getSalesforceEndpoints()

  if (submitForm) {
    submitForm.addEventListener(`click`, e => {
      e.preventDefault()

      contactForm.setAttribute(`action`, action_contact_url)

      window.dataLayer.push({
        event: `contactuscontactussubmitted`,
        businessType: businessType.value,
      })
      contactForm.submit()
    })
  }
}

export default register(`index-contact`, {
  onLoad() {
    ContactForm()
  },

  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload() {
  },
})